import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import LoadingSpinner from '@/components/LoadingSpinner'

const ResinRecipe = lazy(
  async () => import('@/pages/getRecipe/modelMaking/stumpShade'),
)
const PrinedModelMaking = lazy(
  async () => import('@/pages/getRecipe/modelMaking/stumpShadeStaining'),
)

const ModelMakingRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="resin-recipe" element={<ResinRecipe />} />
        <Route
          path="3d-printed-model-staining"
          element={<PrinedModelMaking />}
        />
      </Routes>
    </Suspense>
  )
}

export default ModelMakingRoutes
